import React, {Component} from 'react';
import { Link } from 'react-router-dom';
//import { SelectListComponent } from 'shared-components';
import axios from 'axios';

export default class UserProjects extends Component {

	constructor(props)
	{
		console.log(props);
		super(props);
		this.state = {
			selectedUserProjectId : 0,
			userProjects : []
		};
		//this.handleDelete = this.handleDelete.bind(this);
	}
	componentDidMount() 
	{
		this.handleOnLoad();
	}

	handleOnLoad = () => {
  		axios.get(`${global.config.apiServicesUrl}/user-projects?filter[where][createUser][eq]=${this.props.userId}`).then(res => {
	 	this.setState({ userProjects : res.data});
		});
	
	}
	handleChange = (event) => {
		let rid = event.target.value;
		console.log('rid ' + rid);
		axios.get(`${global.config.apiServicesUrl}/user-project?filter[where][UserProjectId]=${event.target.value}`).then(res => {
			const userProjects = res.data;
  			console.log(userProjects);
 			this.setState({ userProjects : userProjects });
			this.setState({ selectedUserProjectId : rid });
		});
	}

	handleDelete = (id, event) => {

		event.preventDefault();
		console.log('deleting id - ' + id);
  		axios.delete(`${global.config.apiServicesUrl}/UserProject-steps/${id}`).then(res => {
			const response = res.data;
	  		console.log(response);
		});		
		this.setState({userProjects : []});
		let rid = this.state.selectedUserProjectId;
		axios.get(`${global.config.apiServicesUrl}/UserProject-steps?filter[where][UserProjectId]=${rid}`).then(res => {
			const userProjects = res.data;
  			console.log(userProjects);
 			this.setState({ userProjects : userProjects });
			this.setState({ selectedUserProjectId : rid });
		});
	}

	render(){
	return (


				<div class="m-content">				
			<div class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body">
       				<div class="m-grid__item m-grid__item--fluid m-wrapper">
					<div class="m-subheader ">					
						<div class="d-flex align-items-center">
							<div class="mr-auto">
								<h3 class="m-subheader__title m-subheader__title--separator">Gazelle CORE</h3>
								<ul class="m-subheader__breadcrumbs m-nav m-nav--inline">
									<li class="m-nav__item m-nav__item--home">
										<a href="index.html" class="m-nav__link m-nav__link--icon">
											<i class="m-nav__link-icon la la-home"></i>
										</a>
									</li>
									<li class="m-nav__separator">-</li>
									<li class="m-nav__item">
										<a href="index.html" class="m-nav__link">
											<span class="m-nav__link-text">Home</span>
										</a>
									</li>
								</ul>
							</div>
							<div>
								<span class="m-subheader__daterange" id="m_dashboard_daterangepicker">
									<span class="m-subheader__daterange-label">
										<span class="m-subheader__daterange-title"></span>
										<span class="m-subheader__daterange-date m--font-brand"></span>
									</span>
									<a href="index.html" class="btn btn-sm btn-brand m-btn m-btn--icon m-btn--icon-only m-btn--custom m-btn--pill">
										<i class="la la-angle-down"></i>
									</a>
								</span>
							</div>
						</div>
						<br />

					<div className="content-wrapper">

													<div class="col">
														<h3 class="m-widget1__title">
															Projects
														</h3>
														<center>
														<input class="form-control input-xlarge col-sm-8" placeholder="Filter" />
														</center>
													</div>


			<table class="table table-bordered table-striped">
			<thead>
	                        <tr>
					<th scope="col">#</th>
					<th scope="col">Project Name</th>
					<th scope="col">Description</th>
					<th scope="col">Action</th></tr>
			</thead>
			<tbody>{this.state.userProjects.map(({userProjectId, projectName, projectDescr}) => {
				return <tr>
					<td><Link to={{ pathname: "/project-viewer", search : `?id=${userProjectId}` }}>{userProjectId}</Link></td>
					<td><Link to={{ pathname: "/project-viewer", search : `?id=${userProjectId}` }}>{projectName}</Link></td>
					<td><Link to={{ pathname: "/project-viewer", search : `?id=${userProjectId}` }}>{projectDescr}</Link></td>
					<td class="col-sm-2">
						<button class="btn btn-danger btn-sm" onClick={(e) => this.handleDelete(userProjectId, e) }>Delete</button>
					</td>
				</tr>
	                        }) 
	                }
	                </tbody>

	                </table>
											</div>

											</div>
            </div>
            
			</div>
			</div>
			


);


}
}
